import { type Procedimento } from '@framework/api-client/api/backoffice/schemas/procedimento.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { TableCellEllipsis } from '@framework/ui/components/table/TableCellEllipsis.tsx';
import { type ColumnType } from 'antd/es/table';
import { type ColumnGroupType } from 'antd/lib/table';
import { DossierStateTag } from '../components/DossierStateTag.tsx';
import { DossierApplicantTableCell } from './applicant/DossierApplicantTableCell.tsx';

const dateFormat = 'DD/MM/YYYY HH:mm';
const parseDateFormat = 'DD/MM/YYYY HH:mm:ss';

export const dossiersColumnsBase: Record<
  string,
  ColumnGroupType<Procedimento> | ColumnType<Procedimento>
> = {
  denominazione: {
    title: 'Denominazione',
    dataIndex: 'denominazione',
    key: 'denominazione',
    sortDataIndex: 'NOME_TIPO_PROCEDIMENTO',
    render: (_, record) =>
      record.pratica?.tipoPratica?.denominazioneTipoProcedimento,
  },
  oggetto: {
    title: 'Oggetto',
    dataIndex: 'oggetto',
    key: 'oggetto',
    sortDataIndex: 'OGGETTO',
    sorter: true,
    render: (_, record) => (
      <TableCellEllipsis strong tooltip={false} expandable={false}>
        {record.oggetto}
      </TableCellEllipsis>
    ),
  },
  numero: {
    title: 'Numero Pratica',
    dataIndex: 'numero',
    key: 'numero',
    sortDataIndex: 'NUMERO',
    sorter: true,
    render: (_, record) => record.numero,
  },
  stato: {
    title: 'Stato',
    dataIndex: 'stato',
    key: 'stato',
    sortDataIndex: 'STATO_PRATICA',
    sorter: true,
    render: (_, record) => <DossierStateTag state={record.pratica?.stato} />,
  },
  dataAvvio: {
    title: 'Data avvio',
    dataIndex: 'dataAvvio',
    key: 'dataAvvio',
    width: 160,
    showInExpandedRow: true,
    render: date => (
      <ISODate date={date} format={dateFormat} parseFormat={parseDateFormat} />
    ),
  },
  dataUltimaModifica: {
    title: 'Data modifica',
    dataIndex: 'dataUltimaModifica',
    key: 'dataUltimaModifica',
    width: 160,
    sortDataIndex: 'DATA_ULTIMA_MODIFICA',
    sorter: true,
    showInExpandedRow: true,
    render: date => (
      <ISODate date={date} format={dateFormat} parseFormat={parseDateFormat} />
    ),
  },
  tipoDomandaAvvio: {
    title: 'Domanda di Avvio',
    dataIndex: 'tipoDomandaAvvio',
    key: 'pratica.richiestaAvvio.tipoDomanda.titolo',
    render: (_, record) => (
      <TableCellEllipsis tooltip={false} expandable={false}>
        {record.pratica?.richiestaAvvio?.tipoDomanda?.titolo}
      </TableCellEllipsis>
    ),
  },
  dataInvio: {
    title: 'Data invio',
    dataIndex: 'dataInvio',
    key: 'dataInvio',
    width: 160,
    render: date => (
      <ISODate date={date} format={dateFormat} parseFormat={parseDateFormat} />
    ),
  },
  numeroRichiesta: {
    title: 'Numero Richiesta',
    dataIndex: 'numeroRichiesta',
    key: 'numeroRichiesta',
    render: (_, record) => record.pratica?.richiestaAvvio?.numero,
  },
  titolare: {
    title: 'Titolare',
    dataIndex: 'pratica.personeFisiche',
    key: 'pratica.personeFisiche',
    render: (_, record) => (
      <DossierApplicantTableCell applicants={record.pratica?.personeFisiche} />
    ),
  },
};
